<div class="scaffold-dialog" [style.max-width]="maxWidth || 'inherit'" [style.min-width]="minWidth || 'inherit'" [ngClass]="{
    'dialog-full': size == 'full' && !fit,
    'dialog-wide': size == 'wide' && !fit,
    'dialog-half': size == 'half' && !fit,
    'fit-content': fit,
    'full-height': fullHeight,
    'full-view': fullView
  }">
  <div class="scaffold-dialog-header">
    <div class="scaffold-dialog-title app-heading" *ngIf="title">{{ title }}</div>
    <p-button *ngIf="showCloseButton || showCollapseButton" size="large" (click)="handleClose()" class="scaffold-dialog-close-button"
      variant="text" severity="contrast"
      [icon]="showCollapseButton ? 'fa-solid fa-down-left-and-up-right-to-center' : (showCloseButton ? 'fa-thin fa-xmark' : '')">
    </p-button>
  </div>
  <div class="scaffold-dialog-body">
    <ng-content select="[scaffoldDialogBody]"></ng-content>
  </div>
  <div #dialogButtons class="scaffold-dialog-footer" [ngClass]="{ 'flex-center':buttonsCenter, 'flex-end': buttonsFlexEnd }">
    <ng-content select="[scaffoldDialogButtons]"></ng-content>
  </div>
</div>